// JWTUtils
let token;

export default {
    setToken: t => token = t,
    getToken: () => token,
}